export const environment = {
  production: false,
  apiUrl : `https://dev-app-api.vinnikcpa.com/rbac`,
  redirectUrl: 'http://localhost:4200',
  siteUrl: 'http://dev-app.vinnikcpa.com',
  domen: 'dev-app',
};